import { environment } from "src/configs/constance";

export function getCurrentNetwork() {
  // if (store?.getState()?.bridgeSlice?.sourceChain == sidechainIdHex)
  //   return environment === "testnet" ? NETWORKS.SEPOLIA : NETWORKS.ETH_MAINNET;

  return environment === "testnet" ? NETWORKS.BSC_TESTNET : NETWORKS.BSC_MAINNET;
}

export const BNB = { name: "BNB", symbol: "BNB", decimals: 18 };
export const ETH = { name: "ETH", symbol: "ETH", decimals: 18 };

export const NETWORKS = {
  BSC_MAINNET: {
    chainId: "0x38",
    blockExplorerUrls: ["https://bscscan.com"],
    chainName: "BSC Mainnet",
    nativeCurrency: BNB,
    rpcUrls: [
      "https://bsc-dataseed1.binance.org/",
      "https://bsc-dataseed.binance.org/",
      "https://bsc-dataseed1.defibit.io/",
      "https://bsc-dataseed2.defibit.io/",
      "https://bsc-dataseed1.ninicoin.io/",
      "https://bsc-dataseed2.ninicoin.io/",
    ],
  },
  BSC_TESTNET: {
    chainId: "0x61",
    blockExplorerUrls: ["https://testnet.bscscan.com"],
    chainName: "BSC Testnet",
    nativeCurrency: BNB,
    rpcUrls: [
      "https://data-seed-prebsc-2-s2.binance.org:8545/",
      "https://data-seed-prebsc-1-s3.binance.org:8545/",
      "https://data-seed-prebsc-2-s1.binance.org:8545/",
      "https://data-seed-prebsc-1-s1.binance.org:8545/",
      "https://data-seed-prebsc-1-s2.binance.org:8545/",
      "https://data-seed-prebsc-2-s3.binance.org:8545/",
    ],
  },
  ETH_MAINNET: {
    chainId: "0x1",
    blockExplorerUrls: ["https://etherscan.io/"],
    chainName: "Ethereum",
    nativeCurrency: ETH,
    rpcUrls: ["https://eth-rpc.gateway.pokt.network", "https://eth.llamarpc.com", "https://ethereum.publicnode.com"],
  },
  SEPOLIA: {
    chainId: "0xaa36a7",
    blockExplorerUrls: ["https://sepolia.etherscan.io/"],
    chainName: "Sepolia",
    nativeCurrency: ETH,
    rpcUrls: ["https://sepolia.infura.io/v3/8847d2d9d82947abadfa225cb777e922"],
  },
};
